// Arabic module 20 strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enAi } from './en-ai.ts';
import type { Message } from './types.ts';

export const arAi: { readonly [K in keyof typeof enAi]: Message } = {
  'nav.ai': 'المساعدة بالذكاء الاصطناعي',
  'specialist.ai-administrator': 'مسؤول إعداد الذكاء الاصطناعي (التشغيل والمزوّد واستخدام البيانات الشخصية)',

  'ai.api.entitlement': 'لا تملك هذه المؤسسة إضافة الذكاء الاصطناعي لهذا النوع من المساعدة.',
  'ai.api.disabled': 'المساعدة بالذكاء الاصطناعي متوقفة في هذه المؤسسة.',
  'ai.api.domainOff': 'لا يُسمح للذكاء الاصطناعي بقراءة هذا النوع من البيانات في هذه المؤسسة.',
  'ai.api.providerUnavailable': 'مزوّد الذكاء الاصطناعي المختار في الإعدادات غير متاح في هذا التثبيت.',
  'ai.api.identifiable': 'تستخدم رؤى الذكاء الاصطناعي الأرقام الإجمالية فقط؛ هذه النتيجة تُعرّف بأشخاص.',
  'ai.api.notReviewable': 'لا يمكن مراجعة إلا نتيجة ذكاء اصطناعي مكتملة.',
  'ai.v.provider_required': 'اختر مزوّدًا قبل تشغيل الذكاء الاصطناعي.',
  'ai.v.provider_unavailable': 'هذا المزوّد غير متاح أو غير مُهيّأ في هذا التثبيت.',
  'ai.v.no_domains': 'اسمح بمجال بيانات واحد على الأقل قبل تشغيل الذكاء الاصطناعي.',
  'ai.v.residency_note_required': 'يحتاج المزوّد الخارجي إلى ملاحظة عن معالجة البيانات وإقامتها.',
  'ai.v.range': 'خارج النطاق المسموح.',
  'ai.v.minimum_below_threshold': 'لا يمكن أن يكون الحد الأدنى للأدلة أصغر من حد المجموعات الصغيرة.',
  'ai.v.entitlement_missing': 'لا تملك المؤسسة أي استحقاق لإضافة الذكاء الاصطناعي.',

  'ai.rule.basis': 'الأشخاص ضمن النطاق: {people}؛ المجموعات الظاهرة: {groups}.',
  'ai.rule.concentration': 'تمثّل المجموعة {group} نسبة {share}% من جميع من في النطاق ({count}).',
  'ai.rule.spread': 'النشاط موزّع: أكبر مجموعة هي {group} بنسبة {share}% من جميع من في النطاق ({count}).',
  'ai.rule.peakDay': 'أكثر الأيام ازدحامًا في الفترة كان {group} ({count}).',
  'ai.rule.noShowOverall': 'نسبة عدم الحضور الإجمالية: {rate}% ({count}).',
  'ai.rule.noShowHigh': 'نسبة عدم الحضور في {group} هي {rate}% مقابل {overall}% إجمالًا.',
  'ai.rule.now.uncertain': { one: 'سجل حضور واحد غير مؤكد الآن.', other: '{count} من سجلات الحضور غير مؤكدة الآن.' },
  'ai.rule.now.overdue': { one: 'شخص واحد تجاوز نهاية زيارته الآن.', other: '{count} أشخاص تجاوزوا نهاية زياراتهم الآن.' },
  'ai.rule.now.waiting': { one: 'شخص واحد ينتظر الآن.', other: '{count} أشخاص ينتظرون الآن.' },
  'ai.rule.exceptions': '{active} حالات عدم حضور نشطة؛ وسُحب لاحقًا {withdrawn} من التصنيفات.',
  'ai.lim.durationUnknown': '{share}% من المدد غير معروفة، لذا أرقام المدة غير مكتملة.',
  'ai.lim.openReviews': { one: 'سجل حضور واحد قيد المراجعة؛ أرقام الحضور تشمل سجلات غير مؤكدة.', other: '{count} من سجلات الحضور قيد المراجعة؛ أرقام الحضور تشمل سجلات غير مؤكدة.' },
  'ai.lim.truncated': 'اقتُطع التقرير عند حدّ الصفوف؛ لم تُحلَّل بعض المجموعات.',
  'ai.lim.suppressed': { one: 'أُخفيت مجموعة صغيرة واحدة ولم تُحلَّل.', other: 'أُخفيت {count} من المجموعات الصغيرة ولم تُحلَّل.' },
  'ai.lim.unavailableSources': { one: 'مصدر بيانات واحد غير متاح في هذا الإصدار.', other: '{count} من مصادر البيانات غير متاحة في هذا الإصدار.' },
  'ai.lim.rules': 'أُنشئ بواسطة قواعد، وليس بنموذج لغوي. يصف الأرقام ولا يفسّر الأسباب ولا يحكم على الأشخاص.',
  'ai.lim.advisory': 'استشاري فقط. هذا الملخص ليس قرارًا ولا تصويتًا ولا سببًا؛ سجّل قرارك بنفسك في صندوق الموافقات.',
  'ai.lim.untrustedText': 'العنوان والغرض نص كتبه أشخاص. يُعرضان كبيانات ولا يُتّبعان أبدًا كتعليمات.',
  'ai.rec.review_in_inbox': 'سجّل قرارك، مع سببك أنت، في صندوق الموافقات.',
  'ai.rec.review_visit_changes': 'افتح الزيارة وراجِع ما تغيّر.',
  'ai.rec.confirm_identity_at_arrival': 'تحقّق من طريقة التحقق من الهوية عند الوصول.',
  'ai.rec.confirm_escort_arrangements': 'أكّد ترتيبات المرافقة للوجهة المقيّدة.',
  'ai.rec.ask_host_for_information': 'اسأل المضيف عن الصياغة غير المعتادة في الطلب.',
  'ai.rec.verify_figures': 'تحقّق من هذه العبارات مقابل أرقام التقرير.',
  'ai.rec.investigate_pattern': 'ادرس النمط في التقرير قبل استخلاص النتائج.',
  'ai.rec.review_data_quality': 'راجِع جودة البيانات أولًا (حضور غير مؤكد أو مدد غير معروفة).',
  'ai.ds.stage': 'تحتاج المرحلة إلى {quorum} موافقة؛ المسجّل حتى الآن: {approvals} موافقة و{rejections} رفض.',
  'ai.ds.changed': 'تغيّر منذ آخر قرار: {fields}. القرارات السابقة على هذا المشارك: {decisions}.',
  'ai.ds.noChange': 'لا تغييرات مسجّلة على الزيارة منذ آخر قرار. القرارات السابقة على هذا المشارك: {decisions}.',
  'ai.ds.noWarnings': 'لا تحذيرات مفتوحة بين الحقائق التي جرى تقييمها.',
  'ai.ds.warn.restricted_destination': 'الوجهة منطقة مقيّدة.',
  'ai.ds.warn.identity_required_unsatisfied': 'التحقق من الهوية مطلوب لهذا النوع من الزوار ولم يكتمل بعد.',
  'ai.ds.warn.identity_warn_unsatisfied': 'يُستحسن التحقق من الهوية لهذا النوع من الزوار ولم يكتمل بعد.',
  'ai.ds.warn.reviewed_version_stale': 'تغيّرت الزيارة بعد إنشاء مهمة الموافقة هذه.',
  'ai.ds.warn.changed_since_last_decision': 'تغيّرت الزيارة منذ آخر قرار على هذا المشارك.',
  'ai.ds.warn.starts_within_day': 'تبدأ الزيارة خلال 24 ساعة.',
  'ai.ds.warn.quorum_in_progress': 'سجّل موافقون آخرون أصواتهم بالفعل في هذه المرحلة.',
  'ai.ds.warn.instruction_like_text': 'يتضمن العنوان أو الغرض صياغة موجّهة إلى مساعد أو تطلب إجراء وصول؛ عوملت كبيانات فقط.',
  'ai.fact.stage': 'المرحلة {stage}: النصاب {quorum}؛ سُجّل {approvals} موافقة و{rejections} رفض.',
  'ai.fact.policy': 'جرى التقييم وفق نسخة سياسة الزوار {version}.',
  'ai.fact.category': 'نوع الزائر: {category}.',
  'ai.fact.destinationRestricted': 'مستوى أمن الوجهة: مقيّد.',
  'ai.fact.destinationOrdinary': 'الوجهة ليست منطقة مقيّدة.',
  'ai.fact.versions': 'نسخة الزيارة التي راجعتها المهمة: {reviewed}؛ النسخة الحالية: {current}.',
  'ai.fact.approval': 'حالة موافقة المشارك: {status}.',
  'ai.fact.presence': 'حالة حضور المشارك: {status}.',
  'ai.fact.credential': 'حالة بيانات اعتماد المشارك: {status}.',
  'ai.fact.window': 'مدة نافذة الزيارة: {minutes} دقيقة.',
  'ai.fact.startsIn': 'تبدأ بعد نحو {hours} ساعة.',
  'ai.fact.identity': 'متطلب الهوية: {requirement}؛ الحالة الحالية: {status}.',
  'ai.fact.identityNone': 'تعذّرت قراءة متطلب هوية لهذا المشارك.',
  'ai.fact.changes': 'الحقول المتغيّرة منذ آخر قرار: {fields} (القرارات السابقة: {decisions}).',
  'ai.fact.noChanges': 'لا تغييرات مسجّلة على الزيارة منذ آخر قرار (القرارات السابقة: {decisions}).',
  'ai.fact.freeText': 'يتضمن الملخص العنوان والغرض (نص غير موثوق كتبه أشخاص).',

  'ai.ui.eyebrow': 'الذكاء',
  'ai.ui.title': 'المساعدة بالذكاء الاصطناعي',
  'ai.ui.intro': 'مساعدة مستقلة الاستحقاق ومبنية على الأدلة. يبقى كل إجراء ذي أثر بيد إنسان.',
  'ai.ui.offTitle': 'المساعدة بالذكاء الاصطناعي غير مفعّلة',
  'ai.ui.offBody': 'هذه الإضافة الاختيارية تتطلب استحقاقًا مستقلًا (المؤسسات وما فوق) ويجب أن يشغّلها مسؤول إعداد الذكاء الاصطناعي. تعمل الموافقات والتقارير وكل سير العمل الأخرى كما هي بدونها.',
  'ai.ui.tab.insights': 'التقارير والرؤى',
  'ai.ui.tab.decisions': 'دعم القرار',
  'ai.ui.tab.activity': 'سجل النشاط',
  'ai.ui.tab.settings': 'إعدادات الذكاء الاصطناعي',
  'ai.ui.insightsIntro': 'اطلب رؤية من تقرير يمكنك تشغيله أصلًا: افتح التقارير الإجمالية وشغّل التقرير ثم اختر «اطلب رؤية». تقرأ الرؤى الأرقام الإجمالية المعروضة فقط.',
  'ai.ui.openReports': 'افتح التقارير الإجمالية',
  'ai.ui.decisionsIntro': 'في صندوق الموافقات، يمكن للموافق فتح «تلخيص الحقائق» أثناء مراجعة الطلب. الملخص استشاري؛ ولا يُسجَّل القرار إلا بواسطة شخص في الصندوق.',
  'ai.ui.openInbox': 'افتح صندوق الموافقات',
  'ai.ui.history': 'نتائجك من الذكاء الاصطناعي',
  'ai.ui.noRuns': 'لا توجد نتائج ذكاء اصطناعي بعد.',
  'ai.ui.col.when': 'وقت الطلب',
  'ai.ui.col.kind': 'النوع',
  'ai.ui.col.status': 'الحالة',
  'ai.ui.col.subject': 'الموضوع',
  'ai.ui.col.adapter': 'المحوّل',
  'ai.ui.col.by': 'طلبه',
  'ai.ui.col.discarded': 'عناصر مستبعدة',
  'ai.ui.col.reviews': 'المراجعات',
  'ai.ui.open': 'فتح',
  'ai.ui.kind.insight': 'رؤية',
  'ai.ui.kind.decision_support': 'دعم القرار',
  'ai.ui.status.queued': 'قيد التحضير',
  'ai.ui.status.completed': 'جاهز',
  'ai.ui.status.no_supported_insight': 'لا رؤية مدعومة',
  'ai.ui.status.unavailable': 'غير متاح',
  'ai.ui.status.cancelled': 'أُلغي',
  'ai.ui.status.withheld': 'محجوب',
  'ai.ui.reason.insufficient_data': 'لا توجد بيانات كافية ضمن النطاق لدعم رؤية.',
  'ai.ui.reason.stale_data': 'التصنيف الأساسي قديم، لذا لا توجد رؤية مدعومة.',
  'ai.ui.reason.stale_evidence': 'صارت الأرقام قديمة جدًا قبل أن يبدأ التحليل. شغّل التقرير مجددًا.',
  'ai.ui.reason.identifiable': 'لا تُحلَّل أبدًا النتائج التي تُعرّف بأشخاص.',
  'ai.ui.reason.timeout': 'لم يُجب مزوّد الذكاء الاصطناعي في الوقت المحدد. النتيجة غير معروفة؛ لا يُعرض شيء.',
  'ai.ui.reason.error': 'فشل مزوّد الذكاء الاصطناعي. لا يُعرض شيء.',
  'ai.ui.reason.refused': 'رفض مزوّد الذكاء الاصطناعي الإجابة. لا يُعرض شيء.',
  'ai.ui.reason.invalid_output': 'أعاد مزوّد الذكاء الاصطناعي إجابة غير صالحة للاستخدام. لا يُعرض شيء.',
  'ai.ui.reason.not_configured': 'مزوّد الذكاء الاصطناعي غير مُهيّأ في هذا التثبيت.',
  'ai.ui.reason.provider_none': 'لم يُختر مزوّد للذكاء الاصطناعي.',
  'ai.ui.reason.disabled': 'أُوقف الذكاء الاصطناعي.',
  'ai.ui.reason.domain_off': 'مجال البيانات هذا غير مسموح للذكاء الاصطناعي.',
  'ai.ui.reason.entitlement_missing': 'انتهى استحقاق إضافة الذكاء الاصطناعي.',
  'ai.ui.reason.provider_changed': 'تغيّر مزوّد الذكاء الاصطناعي بعد الطلب.',
  'ai.ui.reason.settings_changed': 'أُوقف استخدام البيانات الشخصية بعد الطلب.',
  'ai.ui.reason.permission_lost': 'تغيّر وصولك إلى البيانات الأساسية، لذا حُجبت النتيجة.',
  'ai.ui.reason.requester_inactive': 'الحساب الطالب لم يعد نشطًا.',
  'ai.ui.reason.task_closed': 'أُغلقت مهمة الموافقة قبل إعداد الملخص.',
  'ai.ui.reason.provider_unavailable': 'مزوّد الذكاء الاصطناعي غير متاح.',
  'ai.ui.preparing': 'جارٍ تحضير النتيجة…',
  'ai.ui.generator.rules': 'أُنشئ بواسطة قواعد، وليس بنموذج لغوي',
  'ai.ui.generator.language_model': 'أُنشئ بواسطة نموذج لغوي',
  'ai.ui.external': 'معالج خارجي: غادرت بيانات مختصرة هذا التثبيت',
  'ai.ui.provenance': 'المصدر',
  'ai.ui.prov.adapter': 'المحوّل',
  'ai.ui.prov.model': 'النموذج / نسخة القواعد',
  'ai.ui.prov.prompt': 'قالب التوجيه',
  'ai.ui.prov.asOf': 'الأرقام حتى',
  'ai.ui.prov.digest': 'بصمة الأدلة',
  'ai.ui.prov.personal': 'البيانات الشخصية',
  'ai.ui.prov.personalNo': 'غير مضمّنة (أرقام إجمالية ورموز حقائق فقط)',
  'ai.ui.prov.personalYes': 'مضمّنة وفق ما تسمح به إعدادات الذكاء الاصطناعي',
  'ai.ui.findings': 'النتائج',
  'ai.ui.noFindings': 'لا تدعم الأدلة أي نتائج.',
  'ai.ui.confidence.low': 'ثقة منخفضة',
  'ai.ui.confidence.medium': 'ثقة متوسطة',
  'ai.ui.confidence.high': 'ثقة عالية',
  'ai.ui.cites': 'تحقّق مقابل',
  'ai.ui.followUps': 'خطوات المراجعة المقترحة',
  'ai.ui.followUpNote': 'تفتح خطوة المراجعة سير العمل المعتاد. لا يُنفَّذ شيء نيابةً عنك.',
  'ai.ui.limitations': 'القيود',
  'ai.ui.evidence': 'الأدلة (الأرقام التي يُتحقق مقابلها)',
  'ai.ui.facts': 'الحقائق التي جرى تقييمها (للقراءة فقط)',
  'ai.ui.freeText': 'نص غير موثوق كتبه أشخاص',
  'ai.ui.freeTitle': 'العنوان',
  'ai.ui.freePurpose': 'الغرض',
  'ai.ui.suppressed': 'مُخفاة (مجموعة صغيرة)',
  'ai.ui.metric': 'الرقم',
  'ai.ui.group': 'المجموعة',
  'ai.ui.value': 'القيمة',
  'ai.ui.discarded': { one: 'استبعد حارس السلامة عنصرًا واحدًا من إجابة المزوّد ولا يُعرض.', other: 'استبعد حارس السلامة {count} من عناصر إجابة المزوّد ولا تُعرض.' },
  'ai.ui.stale': 'تغيّرت الزيارة أو المهمة بعد إعداد هذا الملخص. لا تعتمد عليه؛ لخّص مجددًا عند الحاجة.',
  'ai.ui.review': 'مراجعة بشرية لنصيحة الذكاء الاصطناعي',
  'ai.ui.reviewSub': 'تسجيل الحكم لا يتخذ أي إجراء تشغيلي.',
  'ai.ui.disposition': 'الحكم',
  'ai.ui.disp.useful': 'مفيدة',
  'ai.ui.disp.wrong': 'خاطئة',
  'ai.ui.disp.needs_more_evidence': 'تحتاج إلى أدلة أكثر',
  'ai.ui.disp.accepted_for_follow_up': 'قُبلت للمتابعة',
  'ai.ui.disp.dismissed': 'رُفضت',
  'ai.ui.note': 'ملاحظة (اختيارية)',
  'ai.ui.recordReview': 'تسجيل المراجعة',
  'ai.ui.reviews': 'المراجعات',
  'ai.ui.askInsight': 'اطلب رؤية',
  'ai.ui.askInsightHint': 'استشارية، من هذه الأرقام الإجمالية فقط.',
  'ai.ui.insightQueued': 'طُلبت الرؤية.',
  'ai.ui.viewInsight': 'افتح الرؤية',
  'ai.ui.dsTitle': 'تلخيص الحقائق',
  'ai.ui.dsLabel': 'استشاري فقط · لا صلاحية للموافقة أو بيانات الاعتماد أو البوابات',
  'ai.ui.dsOpen': 'تلخيص الحقائق',
  'ai.ui.dsHint': 'اختياري. يمكنك تسجيل قرارك دون فتح هذا.',
  'ai.ui.dsAgain': 'لخّص مجددًا',
  'ai.ui.settingsIntro': 'يبقى الذكاء الاصطناعي متوقفًا ما لم تملك المؤسسة استحقاق إضافة الذكاء الاصطناعي ويشغّله مسؤول إعداد الذكاء الاصطناعي.',
  'ai.ui.entitlements': 'الاستحقاقات',
  'ai.ui.ent.insights': 'التقارير والرؤى بالذكاء الاصطناعي',
  'ai.ui.ent.decisionSupport': 'دعم القرار بالذكاء الاصطناعي',
  'ai.ui.ent.held': 'مُتاح',
  'ai.ui.ent.notHeld': 'غير مُتاح',
  'ai.ui.enabled': 'تشغيل المساعدة بالذكاء الاصطناعي',
  'ai.ui.provider': 'المزوّد',
  'ai.ui.provider.none': 'لا شيء (الذكاء الاصطناعي غير متاح)',
  'ai.ui.provider.local-rules': 'قواعد محلية (دون اتصال، حتمية؛ ليست نموذجًا لغويًا)',
  'ai.ui.provider.anthropic': 'Anthropic (نموذج لغوي خارجي)',
  'ai.ui.provider.unavailable': 'غير متاح',
  'ai.ui.domains': 'البيانات التي يجوز للذكاء الاصطناعي قراءتها',
  'ai.ui.domain.reporting': 'التقارير الإجمالية (الرؤى)',
  'ai.ui.domain.approvals': 'حقائق الموافقات (دعم القرار)',
  'ai.ui.personal': 'السماح بتضمين البيانات الشخصية (الأسماء والعناوين والأغراض)',
  'ai.ui.personalHint': 'متوقف افتراضيًا: يقرأ الذكاء الاصطناعي الأرقام الإجمالية ورموز الحقائق فقط، وتصبح المجموعات الشخصية أسماء مستعارة.',
  'ai.ui.threshold': 'حد المجموعات الصغيرة',
  'ai.ui.thresholdHint': 'تُخفى المجموعات الأصغر من هذا الحد قبل التحليل.',
  'ai.ui.minimum': 'الحد الأدنى للأشخاص ضمن النطاق',
  'ai.ui.minimumHint': 'دون هذا الحد لا توجد رؤية مدعومة.',
  'ai.ui.maxAge': 'أقصى عمر للأرقام (بالدقائق)',
  'ai.ui.residency': 'ملاحظة معالجة البيانات وإقامتها',
  'ai.ui.residencyHint': 'مطلوبة للمزوّد الخارجي: أين تُعالج البيانات وبموجب أي اتفاق. تُسجَّل ولا يتحقق منها Passage.',
  'ai.ui.retention': 'تُحفظ نتائج الذكاء الاصطناعي ومراجعاتها ضمن فئة الاحتفاظ «ai_records» (الخصوصية والاحتفاظ).',
  'ai.ui.save': 'حفظ إعدادات الذكاء الاصطناعي',
  'ai.ui.saved': 'حُفظت إعدادات الذكاء الاصطناعي.',
  'ai.ui.readOnly': 'لا يغيّر هذه الإعدادات إلا مسؤول إعداد الذكاء الاصطناعي.',
  'ai.ui.killTitle': 'أوقف الذكاء الاصطناعي الآن',
  'ai.ui.killBody': 'يوقف كل ميزات الذكاء الاصطناعي فورًا للمؤسسة كلها ويلغي النتائج قيد التحضير. تستمر الموافقات والتقارير في العمل.',
  'ai.ui.killReason': 'السبب',
  'ai.ui.killConfirm': 'أوقف الذكاء الاصطناعي',
  'ai.ui.disabledAt': 'أُوقف {time}: {reason}',
  'ai.ui.activityIntro': 'من طلب ماذا وبأي محوّل. لا تُعرض المدخلات والمخرجات هنا.',
  'ai.ui.noActivity': 'لا نشاط للذكاء الاصطناعي بعد.',
  'ai.ui.subject.report': 'التقرير {definition}',
  'ai.ui.subject.task': 'مهمة موافقة',
};
